import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import { User } from '../models/user';
import { LoginService } from '../services/login.service';
import { ValidationService } from '../services/validation.service';
import { first } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../services/user.service';
import { environment } from 'src/environments/environment';
import { CommonService } from '../services/common.service';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: true,
    imports: [TranslateModule, FormsModule, CommonModule]
})
export class LoginComponent implements OnInit, AfterViewInit {
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  @ViewChild('updatePassword') chnagepassword: TemplateRef<any>
  msg: string = "";
  PopoldPassword: any;
  PopnewPassword: any;
  PopconfirmPassword: any;

  showPassword: boolean = false;
  showForgotPasswordForm: boolean = false;
  otpSent: boolean = false;
  userEmail: string = '';
  otp: string = '';
  newPassword: string = '';
  confirmPassword: string = '';

  userObj: User = new User();
  currentUser: any;

  isError: boolean = false;
  errorMessage: any;
  private baseUrl = environment.baseUrl;
  constructor(
    private validationService: ValidationService,
    private loginService: LoginService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }
ngOnInit() {

  this.route.queryParams.subscribe(params => {
    if (params['saml_error']) {
      this.isError = true;
      switch (params['saml_error']) {
        case 'user_not_found':
          this.errorMessage = 'User not found in database. Please contact your administrator or try logging in with email/password.';
          break;
        case 'no_email_in_profile':
          this.errorMessage = 'Email address not found in SAML profile. Please contact your administrator.';
          break;
        case 'auth_failed':
          this.errorMessage = 'SAML authentication failed. Please try again or use email/password login.';
          break;
        case 'login_error':
          this.errorMessage = 'Login error occurred. Please try again.';
          break;
        case 'server_error':
          this.errorMessage = 'Server error occurred. Please try again later.';
          break;
        default:
          this.errorMessage = 'SAML authentication failed. Please try again.';
      }
    }
    if (params['error']) {
      this.isError = true;
      this.errorMessage = 'Authentication error. Please try again.';
    }
  });

  if (this.currentUser != null && this.currentUser != undefined) {
    this.commonService.setActiveTab('/devices');
    this.router.navigate(['/devices']);
  }
}

clearError() {
  this.isError = false;
  this.errorMessage = '';
  this.router.navigate(['/login'], { replaceUrl: true });
}
  ngAfterViewInit(): void {
    // this.loginService.getToken();
  }
  onSamlLogin() {
     this.isError = false;
  this.errorMessage = '';
    window.location.href = `${this.baseUrl}/auth/saml/login`;
  }
  onLogin() {
    this.isError = false;
    this.errorMessage = '';
    if (!this.validationService.validateNullUndefinedEmptyString(this.userObj.email)) {
      this.isError = true;
      this.errorMessage = 'Please enter username ';
      return;
    }
    else if (!this.validationService.validateEmail(this.userObj.email)) {
      this.isError = true;
      this.errorMessage = 'Please enter valid username ';
      return;
    }
    if (!this.validationService.validateNullUndefinedEmptyString(this.userObj.password)) {
      this.isError = true;
      this.errorMessage = 'Please enter password ';
      return;
    }
    // else if(!this.validationService.validateEmail(this.userObj.password) ){
    //   this.isError=true;
    //   this.errorMessage='Please enter valid Password !!';
    //   return;
    // }
    this.loginService.authenticateUser(this.userObj)
      .pipe(first()).subscribe({
        next: (response: any) => {
          // Handle successful response
          if (response.success == true || response.success == "true") {
            // let str:string
            // str=response.redirect
            // str=str.split('jwt=')[1];
            // let myobj:any={
            //   csrfSecret:'GM0ghdasgfbnvhjgwe',
            //   jwt:this.userObj
            // }
            // let obj=JSON.stringify(myobj)
            // sessionStorage.setItem('session',obj)
            // sessionStorage.setItem('jwt',str)
            // sessionStorage.setItem('email',this.userObj.email)
            // sessionStorage.setItem('password',this.userObj.password)
            // this.loginService.validateJwtToken(response.redirect).pipe(first()).subscribe((authResponse: any) => {
            this.loginService.getUserObject().pipe(first()).subscribe((userObjResponse: any) => {

              let user = new User();
              user.email = this.userObj.email;
              // user.email=response.user.userDataObj.email;
              user.config = userObjResponse.config;
              // user.config=response.user.config
              user.userObj = userObjResponse.user;
              // user.userObj=response.user.userDataObj;
              this.loginService.setcurrentUserSubject(user);
              user.loginMethod = 'normal'; 
              localStorage.setItem('loginMethod', 'normal');
              localStorage.setItem('currentUser', JSON.stringify(user));
              sessionStorage.setItem('currentUser', JSON.stringify(user));//change done here
              sessionStorage.setItem('language', 'en');//language preference
              this.commonService.setActiveTab('/devices');
              this.router.navigate(['/devices']);

              // });
            });
          } else {
            this.isError = true;
            this.errorMessage = response.serviceResponse;
            if (response.error == 'ValidationError') {
              this.openAlertMod(this.alertTemplate, response.validationErrors[0].message)
            }
          }

          let date = new Date().toString()
          let dummydate = date.replace('GMT+0530 (India Standard Time)', '')
          let loginDate = new Date(dummydate).toUTCString()
          // this.loginService.updateLastLogindate(loginDate, this.userObj)
        },
        error: (error) => {
          this.openAlertMod(this.alertTemplate, error.error.validationErrors[0].message);
        }
      });
  }

  mailToProteanSupport() {
    let mail = 'mailto:admin@apmosys.com';
    window.location.href = mail;
  }

  forgotPassword() {
    this.showForgotPasswordForm = !this.showForgotPasswordForm;
    if (this.showForgotPasswordForm)
      this.router.navigate(['/forgotpassword']);
  }

  // Simulate sending OTP to the email
  sendOtp() {
    if (this.userEmail) {
      // Implement logic to send OTP to the user's email.
      this.otpSent = true;
    } else {
      this.msg = "Please enter a valid email";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Please enter a valid email');
    }
  }

  // Handle password reset logic
  resetPassword() {
    if (this.otp && this.newPassword === this.confirmPassword) {
      // Implement password reset logic here.
      this.msg = "Password has been reset successfully";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Password has been reset successfully');
      this.resetForm();
    } else {
      this.msg = "Please check your OTP or passwords.";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Please check your OTP or passwords.');
    }
  }

  // Reset form after successful password reset or cancellation
  resetForm() {
    this.showForgotPasswordForm = false;
    this.otpSent = false;
    this.userEmail = '';
    this.otp = '';
    this.newPassword = '';
    this.confirmPassword = '';
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }


  SaveChnage() {
    if (this.PopconfirmPassword != this.PopnewPassword) {
      this.msg = "Both passwords don't match!";
      this.openAlertMod(this.alertTemplate, this.msg);
    }
    else {
      if (this.PopnewPassword.length > 8) {
        this.loginService.changePass(this.currentUser.userObj.email, this.PopnewPassword, this.PopoldPassword)
          .subscribe((res: any) => {
            if (res.success == true) {
              this.msg = "Password updated successfully!";
              this.openAlertMod(this.alertTemplate, this.msg);
              // let user = new User();
              // user = this.currentUser;
              // sessionStorage.removeItem('currentUser');
              // this.loginService.setcurrentUserSubject(null);
              // this.router.navigate(['/login']);
              // location.reload();
              let user = new User();
              user = this.currentUser;
              // this.loginService.logout(user).pipe(first()).subscribe((response: any) => {
              //   if (response == "Success") {
              //     sessionStorage.removeItem('currentUser');
              //     this.loginService.setcurrentUserSubject(new User());
              //     this.router.navigate(['/login']);
              //     location.reload();
              //   } else {
              //     sessionStorage.removeItem('currentUser');
              //     this.loginService.setcurrentUserSubject(new User());
              //     this.router.navigate(['/login']);
              //     location.reload();
              //     console.error(response);
              //   }
              // });
              localStorage.removeItem('currentUser')
              sessionStorage.removeItem('currentUser');
              localStorage.setItem('logoutEvent', Date.now().toString());
              this.loginService.setcurrentUserSubject(null);
              this.router.navigate(['/login']);
              location.reload();
            }
            if (res.success == false) {
              this.msg = res.description;
              this.openAlertMod(this.alertTemplate, this.msg);
              // alert(res.description);
            }
          },
            ((error: HttpErrorResponse) => {
              // Log the error message
              console.error('Error occurred:', error);

              // Check if the error message matches the condition
              if (error.error && error.error.status === 'Entered password same as current password') {
                // Show modal here
                this.msg = "Entered password same as current password";
                this.openAlertMod(this.alertTemplate, this.msg);
                // alert("Entered password same as current password");
              }
              if (error.error.description == "Forbidden: Invalid email or password") {
                this.msg = "Invalid email or password";
                this.openAlertMod(this.alertTemplate, this.msg);
                // alert("Invalid email or password");
              }


            })


          )
      }
      else {
        this.msg = "Password must be of length >8";
        this.openAlertMod(this.alertTemplate, this.msg);
        // alert("Password must be of length >8")
      }
    }
    this.modalRef.close();;
  }
}
